/**
 * Report Pack API - Generate and download defensibility bundles.
 */

import apiClient, { type RequestConfig } from './client';

export interface ReportPackPreview {
  matter_id: string;
  generated_at: string;
}

export const reportPackApi = {
  /**
   * Download the complete Matter Defensibility Bundle (ZIP).
   */
  async download(matterId: string, config?: RequestConfig): Promise<any> {
    const { data } = await apiClient.get<any>(`/matters/${matterId}/report-pack`, config);
    return data;
  },

  /**
   * Preview the defensibility report (HTML summary).
   */
  async preview(matterId: string, config?: RequestConfig): Promise<string> {
    const { data } = await apiClient.get<string>(`/matters/${matterId}/report-pack/preview`, config);
    return data;
  },

  /**
   * List all pipeline runs for a matter.
   */
  async listRuns(matterId: string, params?: { run_type?: string; limit?: number }, config?: RequestConfig): Promise<any> {
    const { data } = await apiClient.get(`/matters/${matterId}/runs`, {
      ...config,
      params,
    });
    return data;
  },

  /**
   * Get detailed events for a specific run.
   */
  async getRunDetails(matterId: string, runId: string, config?: RequestConfig): Promise<any> {
    const { data } = await apiClient.get(`/matters/${matterId}/runs/${runId}`, config);
    return data;
  },
};

export default reportPackApi;
